import React, { Component } from 'react'
import { Table, Button, message } from 'antd'
import moment from 'moment'
import AuditModal from './auditModal'
import { attendanceReview } from '../../../../api/employee'

export default class fakeAttendance extends Component {
  state = {
    list: [],
    showDetail: false,
    selectItem: null,
  }

  onShowDetail = (record) => {
    console.log(record)
    this.setState({
      showDetail: true,
      selectItem: record,
    })
  }

  // 通过or拒绝
  onStatusHandle = async (id, type) => {
    this.props.requestEvent(true)
    const { status, detail } = await attendanceReview({
      applyId: id,
      status: type,
    })
    if (status != 1) {
      this.props.requestEvent(false)
      message.error(detail)
      return
    }
    this.onCancelHandle()
    this.props.refreshList()
  }

  onCancelHandle = () => {
    this.setState({
      showDetail: false,
    })
  }

  render() {
    const { isloading, list } = this.props
    const { showDetail, selectItem } = this.state
    const columns = [
      {
        title: '日期',
        dataIndex: 'createTime',
        render: (value) => {
          const dateStr = value ? moment(value).format('YYYY-MM-DD') : ''
          return <span>{dateStr}</span>
        },
      },
      {
        title: '员工',
        dataIndex: 'name',
      },
      {
        title: '申请',
        dataIndex: 'type',
        render: (text) => {
          // 申请类型：1.迟到补卡，2.早退补卡，3.缺勤补卡，4.请假，5.加班 6.地址异常补卡'
          var str
          switch (text) {
            case 1:
              str = '迟到补卡'
              break
            case 2:
              str = '早退补卡'
              break
            case 3:
              str = '缺勤补卡'
              break
            case 4:
              str = '休假申请'
              break
            case 5:
              str = '加班申请'
              break
            case 6:
              str = '地址异常补卡'
              break
            default:
              str = ''
              break
          }
          return <span>{str}</span>
        },
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <Button type="primary" onClick={() => this.onShowDetail(record)}>
              详情
            </Button>
          )
        },
      },
    ]
    return (
      <div style={{ width: '70%' }}>
        <Table
          rowKey="id"
          loading={isloading}
          bordered
          size="small"
          columns={columns}
          dataSource={list}
        />
        {showDetail && (
          <AuditModal
            dataSource={selectItem}
            onStatusEvent={this.onStatusHandle}
            onCancel={this.onCancelHandle}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubAttendanceRecord/component/fakeAttendance/fakeAttendance.js